/* eslint-disable jsx-a11y/anchor-is-valid */
import IntroTitle from "./headingSVGs/IntroTitle";
import { PagesEnum } from "./utils";
import "./styles/text.css";

const Intro = ({ setPage }) => (
  <div className="intro">
    <IntroTitle />
    <p>
      In 1996, artist Peter Halley created this interactive digital print in
      conjunction with the exhibition{" "}
      <i>New Concepts in Printmaking 1: Peter Halley</i>. It was based on his
      1994 silk screen print{" "}
      <a>
        <i>Exploding Cell</i>
      </a>
      , acquired by the Museum in 1996.{" "}
    </p>
    <p>
      This interactive print was the first digital artwork acquired by MoMA in
      1996.
    </p>
    <p>
      <a className="start-link" onClick={() => setPage(PagesEnum.GRID)}>
        CLICK HERE to create your own Exploding Cell print.
      </a>
    </p>
    <p className="credits">
      Original design, programming and art direction: Charles Carrico, OVEN
      Digital, Greg Van Alstyne Reprogramming and redesign: Soft Surplus and
      Steph Gonzalez-Turner
    </p>
  </div>
);

export default Intro;
